import { UserAgent } from '@sentry/browser/dist/integrations'
import { NetworkStats } from '@/types/networkstats'
import { KeyDict } from '@/types'
import { ExportableClass } from '.'

export interface ChromaKey {
  balance: number,
  clipblack: number,
  clipwhite: number,
  enabled: boolean,
  screen: string,
  weight: number
}

export const DEFAULT_NOTIFICATION_EXPIRATION = 5 * 60 * 1000 // 5 minutes

export class UserNotification {
  user_id: string = ''
  message: string = ''
  link?: string = ''
  linkLabel?: string = ''
  expires: number = DEFAULT_NOTIFICATION_EXPIRATION + new Date().getTime()
}

export class SelfTestStats extends ExportableClass {
  camerapermission: boolean = false
  hearaudio: boolean = false
  hearpreview: boolean = false
  microphonepermission: boolean = false
  seevideo: boolean = false
  seepreview: boolean = false
  timestamp: number = 0
  region: string = ''
  network: {
    download: NetworkStats,
    upload: NetworkStats
  } = {
    download: new NetworkStats(),
    upload: new NetworkStats()
  }
}

export type maybeBoolean = boolean | null

export enum PreviewVideoQualityType {
  High = 'High',
  Low = 'Low'
}

export enum ChromaKeyPreviewQualityType {
  High = 'High',
  Low = 'Low',
  Off = 'Off'
}

export interface UserMediaDevice {
  id: string,
  name: string,
  type: 'audio' | 'video' | 'output'
}

export interface WebRTCEncoderSettings {
  videoBitrate?: number,
  audioBitrate?: number,
  width?: number,
  height?: number
}

export interface UserProfile {
  agent?: UserAgent,
  avatar?: string,
  id: string,
  email: string,
  first_name: string,
  last_name: string,
  role: string,
  selftestshown?: boolean,
  selfSelveWelcomeShown?: boolean,
  introshown?: boolean,
  version?: string,
  currentTeam?: string,
  teams?: KeyDict<boolean>
  team_id?: string,
  teamGroups?: KeyDict<string[]>
  transcodingregion?: string,
  transcodingregiontext?: string,
  user_id?: string, // deprecated
  display_name?: string,
  display_image?: string,
  chromakey?: ChromaKey,
  notifications: KeyDict<UserNotification>
  selftest?: SelfTestStats
  devices?: UserMediaDevice[],
  selectedAudioDevice?: string,
  selectedVideoDevice?: string,
  encoderSettings?: WebRTCEncoderSettings,
  previewVideoQuality?: PreviewVideoQualityType,
  chromaKeyPreviewQuality?: ChromaKeyPreviewQualityType,
  udpEnabled?: boolean,
  echoSuppression?: boolean,
  legalAgreements: {
    tosVersion: number,
    privacyVersion: number,
    lastUpdateDialog: number | null,
  },
  anonymous: boolean,
  anonymousId?: string,
  assignedId?: string,
  caster_volume?: number,
  sortedTeamGroupNames?: string[]
}

export enum UserRole {
  User = 'user',
  SuperUser = 'superuser'
}

export interface UserOption {
  name: string,
  id: string
}
